module.exports = "<div class=\"dashboard-header flex-wrapper\">\n  <h2 class=\"dashboard-title\">{{ title | firstToUpper }}</h2>\n</div>\n"